import { IBranchDTO, IProductDTO } from '@/dtos';
import { get } from './apiWrapper';

export const getBranchesForYearAPI = async (): Promise<{ data: IBranchDTO[]; count: number }> => {
  const branches = await get<{ data: IBranchDTO[]; count: number }>(`/branches`);
  return branches;
};

export const getBranchYearProductsAPI = async (): Promise<{
  data: IProductDTO[];
  count: number;
}> => {
  const branches = await get<{ data: IProductDTO[]; count: number }>(`/branch/products`);
  return branches;
};
